import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from './ui/sheet';
import { Separator } from './ui/separator';
import InlineProductCreationForm from './InlineProductCreationForm';

const ProductCreationDrawer = ({
  open,
  onClose,
  initialData = {},
  onProductCreated
}) => {
  const handleProductCreated = (newProduct) => {
    if (onProductCreated) {
      onProductCreated(newProduct);
    }
    onClose();
  };

  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent
        side="right"
        className="w-[90vw] max-w-[90vw] p-0 flex flex-col"
      >
        <SheetHeader className="p-6 pb-2">
          <SheetTitle className="flex items-center gap-2">
            创建新产品
          </SheetTitle>
          <SheetDescription>
            根据导入数据创建新产品。创建成功后，将自动应用到订单中。
          </SheetDescription>
        </SheetHeader>

        <Separator />

        <div className="flex-1 overflow-auto px-6 pb-6">
          <InlineProductCreationForm
            isOpen={open}
            onClose={onClose}
            onProductCreated={handleProductCreated}
            initialData={{
              name: initialData?.name || '',
              product_id: initialData?.product_id || '',
              specification: initialData?.specification || '',
              category: initialData?.category || '',
              product_type: initialData?.product_type || 'finished_good',
              unit: initialData?.unit || '个',
              price: initialData?.unit_price || '',
              tip_diameter: initialData?.tip_diameter || '',
              total_length: initialData?.total_length || '',
              searchContext: {
                query: initialData?.product_id || '',
                category: initialData?.category || '',
                clientName: initialData?.client_name || ''
              }
            }}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default ProductCreationDrawer;
